import * as Sentry from '@sentry/react';
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { createRoot } from 'react-dom/client';
import { createBrowserHistory } from 'history';
import { datadogRum } from '@datadog/browser-rum';
import { StrictMode } from 'react';
import App from './landing/index';
import * as serviceWorker from './serviceWorker';
import { setItemToLocalStorage } from '../shared/utils/storage-api';
import { landingResources } from '../i18n/resources';
import { NS } from '../models/I18n';
import './index.css';

const serverData = JSON.parse(document.getElementById('server-data')?.textContent || '{}');

if (process.env.NODE_ENV !== 'production') {
  console.log('serverData', serverData); // eslint-disable-line no-console
}

const history = createBrowserHistory();

Sentry.init({
  dsn: process.env.SENTRY_LANDING_DSN,
  environment: serverData.env.SENTRY_ENV,
  release: serverData.env.RELEASE,
  integrations: [
    new Sentry.BrowserTracing({
      tracingOrigins: [window.location.host, /^\//],
      routingInstrumentation: Sentry.reactRouterV5Instrumentation(history),
    }),
    new Sentry.Replay(),
  ],
  tracesSampleRate: 0.1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

if (process.env.DD_APPLICATION_ID && process.env.DD_CLIENT_TOKEN)
  datadogRum.init({
    applicationId: process.env.DD_APPLICATION_ID,
    clientToken: process.env.DD_CLIENT_TOKEN,
    site: 'datadoghq.com',
    service: 'platform-landing',
    env: process.env.STACK,
    version: process.env.RELEASE,
    sampleRate: 100,
    trackInteractions: true,
  });

i18n.on('languageChanged', (lng) => {
  setItemToLocalStorage('i18nextLng', lng.substring(0, 2));
});

i18n
  .use(LanguageDetector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources: landingResources,
    ns: [NS.Shared],
  });

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App history={history} />
  </StrictMode>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
